<a
    [routerLink]="[{ outlets: { primary: item().route, admin: null } }]"
    [relativeTo]="activatedRoute"
    [attr.aria-label]="'mobile-menu.navigate-to' | translate: { name: (item().label | translate) }"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: false }"
    #linkRef="routerLinkActive"
    [attr.aria-current]="linkRef.isActive ? 'page' : undefined"
    [attr.data-test]="item().testId"
>
    <span>{{ item().label | translate }}</span>
    <app-icon icon="arrow-right" [size]="16" class="fill-neutral-primary" [attr.aria-hidden]="true" role="presentation" />
</a>
